module.exports = __webpack_public_path__ + "static/img/goods-4.e14ee6b8.png";